import { SVGProps } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Accordion, AccordionButton, AccordionPanel, Button, Spacing } from '@zep/ui';
import { isMobile } from '@zep/utils/device';
import { PricingCardProps } from '../../types';
import { PricingCard } from '../PricingCard';
import { FeatureListItem } from './shared';
export const EnterprisePlanCard = (props: PricingCardProps) => {
  const {
    t
  } = useTranslation(['subscription']);
  return <PricingCard.Root data-sentry-element="unknown" data-sentry-component="EnterprisePlanCard" data-sentry-source-file="EnterprisePlanCard.tsx">
      <PricingCard.Header data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
        <div className="flex">
          <div className="flex w-full flex-col">
            <PricingCard.Title data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">Enterprise</PricingCard.Title>
            <PricingCard.TitleDescription data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
              {t('subscription:pricing.enterprise.description')}
            </PricingCard.TitleDescription>
          </div>
          <PricingCard.Logo data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
            <MessageGradientSvg data-sentry-element="MessageGradientSvg" data-sentry-source-file="EnterprisePlanCard.tsx" />
          </PricingCard.Logo>
        </div>
      </PricingCard.Header>
      <PricingCard.Content data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
        {/* 형제 카드의 가격행(h-42) 자리 — subgrid 행 공유로 버튼 라인이 정렬됨 */}
        <div className="h-[42px]" aria-hidden />
        <Spacing size={14} data-sentry-element="Spacing" data-sentry-source-file="EnterprisePlanCard.tsx" />
        <Button isFullWidth className="!bg-[#27262ECC] hover:!bg-gray-900" onClick={props.onClickCardButton} data-sentry-element="Button" data-sentry-source-file="EnterprisePlanCard.tsx">
          {t('subscription:pricing.plansEnterprise.buttonContact')}
        </Button>
      </PricingCard.Content>
      <PricingCard.Footer data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
        {isMobile() ? <Accordion className="!border-none !bg-white">
            <AccordionButton className="text-body-1-sb justify-between !p-0 !text-[14px] font-[600] text-gray-900">
              {t('subscription:pricing.mainFeatures')}
            </AccordionButton>
            <AccordionPanel className="!p-0">
              <Spacing size={16} />
              <FooterContent />
              <Spacing size={14} />
            </AccordionPanel>
          </Accordion> : <FooterContent />}
      </PricingCard.Footer>
    </PricingCard.Root>;
};
const FooterContent = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    locale
  } = useRouter();
  const isLocaleJapanese = locale === 'ja';
  return <div className="flex flex-col" data-sentry-component="FooterContent" data-sentry-source-file="EnterprisePlanCard.tsx">
      <PricingCard.FeatureTitle data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
        {t('subscription:pricing.enterprise.feature1')}
      </PricingCard.FeatureTitle>
      <Spacing size={16} data-sentry-element="Spacing" data-sentry-source-file="EnterprisePlanCard.tsx" />
      <FeatureListItem.Root data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
        {isLocaleJapanese && <FeatureListItem.List>
            <FeatureListItem.Icon />
            <FeatureListItem.Text>
              {t('subscription:pricing.enterprise.feature2')}
            </FeatureListItem.Text>
          </FeatureListItem.List>}
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx" />
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
            {t('subscription:pricing.enterprise.feature3')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx" />
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
            {t('subscription:pricing.enterprise.feature4')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx" />
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
            {t('subscription:pricing.enterprise.feature5')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx" />
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="EnterprisePlanCard.tsx">
            {t('subscription:pricing.enterprise.feature6')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
      </FeatureListItem.Root>
    </div>;
};
const MessageGradientSvg = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} fill="none" {...props} data-sentry-element="svg" data-sentry-component="MessageGradientSvg" data-sentry-source-file="EnterprisePlanCard.tsx">
    <path fill="url(#message-from)" fillRule="evenodd" d="M4.666 4.667A2.333 2.333 0 0 0 2.333 7v12.833a2.333 2.333 0 0 0 2.333 2.334h5.35l3.159 3.158a1.167 1.167 0 0 0 1.65 0l3.158-3.158h5.35a2.333 2.333 0 0 0 2.333-2.334V7a2.333 2.333 0 0 0-2.333-2.333H4.666Zm3.5 5.25a1.167 1.167 0 0 0 0 2.333h11.667a1.167 1.167 0 0 0 0-2.333H8.166Zm0 4.666a1.167 1.167 0 1 0 0 2.334h7a1.167 1.167 0 1 0 0-2.334h-7Z" clipRule="evenodd" data-sentry-element="path" data-sentry-source-file="EnterprisePlanCard.tsx" />
    <defs data-sentry-element="defs" data-sentry-source-file="EnterprisePlanCard.tsx">
      <linearGradient id="message-from" x1={14} x2={14} y1={4.667} y2={25.667} gradientUnits="userSpaceOnUse" data-sentry-element="linearGradient" data-sentry-source-file="EnterprisePlanCard.tsx">
        <stop stopColor="#27262E" data-sentry-element="stop" data-sentry-source-file="EnterprisePlanCard.tsx" />
        <stop offset={1} stopColor="#949CBD" data-sentry-element="stop" data-sentry-source-file="EnterprisePlanCard.tsx" />
      </linearGradient>
    </defs>
  </svg>;